import React, { useState } from 'react';
import { Modal, Image, Button } from 'react-bootstrap';

const ImageGallery = ({ images, title = "معرض الصور" }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);

  const openModal = (imageSrc, index) => {
    setSelectedImage(imageSrc);
    setSelectedIndex(index);
    setShowModal(true);
  };

  const nextImage = () => {
    const nextIndex = (selectedIndex + 1) % images.length;
    setSelectedIndex(nextIndex);
    setSelectedImage(images[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = selectedIndex === 0 ? images.length - 1 : selectedIndex - 1;
    setSelectedIndex(prevIndex);
    setSelectedImage(images[prevIndex]);
  };

  return (
    <>
      <div className="image-gallery">
        {images.map((image, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => openModal(image, index)}
          >
            <img
              src={image}
              alt={`ملابس فاخرة للنساء من moda-lady | Vêtements de luxe pour femmes – moda-lady | Luxury women's clothing – moda-lady – صورة رقم ${index + 1}`}
              className="gallery-thumbnail"
            />
            <div className="gallery-overlay">
              <i className="fas fa-search-plus"></i>
            </div>
          </div>
        ))}
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="image-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="modal-image-container">
            <Button
              variant="outline-secondary"
              className="nav-button prev-button"
              onClick={prevImage}
            >
              ‹
            </Button>
            <Image
              src={selectedImage}
              fluid
              className="modal-image"
              alt={`أفرشة فاخرة مضادة للماء للنساء من سفيان للأفرشة | Linge de lit de luxe et imperméable pour femmes – Soufiane Literie | Luxury & waterproof bedding for women – Soufiane Bedding – صورة مكبرة رقم ${selectedIndex + 1}`}
            />
            <Button
              variant="outline-secondary"
              className="nav-button next-button"
              onClick={nextImage}
            >
              ›
            </Button>
          </div>
          <div className="image-counter">
            {selectedIndex + 1} من {images.length}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageGallery;
